// extracted by mini-css-extract-plugin
module.exports = {"controls":"Submit_controls__t69QF","submitButton":"Submit_submitButton___tRnp"};